
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quizzes",
      function () {
        return require("private-next-pages/quizzes/index.tsx");
      }
    ]);
  